// What this workspace has actually done, as counted by the server (ADR-0016).
//
// The four counts used to be issued from here, as four `head: true` queries
// through PostgREST. They now come back inside `workspace_progress()`, which
// counts them next to the tables and applies the same rule to both clients
// (ADR-0027). It is still the CALLER's visibility that answers them — that
// function is `security invoker` precisely so a member who cannot see the media
// library gets zero, and is told that step belongs to somebody else, rather
// than a number they are not entitled to.
//
// The shape stays here because it is what the strip and the drawer render.

export interface EngagementFacts {
  /** Connections that are not revoked — expired still counts as "you have connected". */
  connections: number;
  posts: number;
  /** Posts with a release time on them, ever. */
  scheduled: number;
  media: number;
}

export const NO_FACTS: EngagementFacts = {
  connections: 0, posts: 0, scheduled: 0, media: 0,
};
